import { forwardRef } from 'react';
import { cn } from '@/shared/utils/cn';
import { formatDisplayPrice } from '@/shared/utils/priceFormatter';

interface SizePriceTickerProps {
  active: boolean;
  category: string;
  selectedSizeValue: string;
  price: number | null;
  discountedPrice: number | null;
}

export const SizePriceTicker = forwardRef<HTMLDivElement, SizePriceTickerProps>(
  function SizePriceTicker(
    { active, category, selectedSizeValue, price, discountedPrice },
    ref
  ) {
    const hasDiscount =
      price !== null && discountedPrice !== null && price !== discountedPrice;
    const isBangles = category === 'Bangles';

    return (
      <div
        ref={ref}
        className={cn(
          'fixed left-0 z-[200] box-border w-full bg-white px-2.5 shadow-[0_0_5px_rgba(0,0,0,0.8)] transition-[top] duration-[250ms] ease-in-out md:hidden',
          isBangles ? 'py-0' : 'py-[15px]',
          active ? 'top-[54px]' : '-top-16'
        )}
        style={{ height: '54px' }}
      >
        <div className={cn('flex h-full items-center justify-between font-semibold', isBangles && 'h-full')}>
          <div className={cn('text-sm leading-[26px]', isBangles && 'flex h-full flex-col justify-center')}>
            Size{' '}
            <span className="inline-block min-w-[21px] rounded-[2px] bg-[#e2e2e2] px-1 py-0.5 text-center text-sm leading-normal">
              {selectedSizeValue}
            </span>
          </div>

          <div className={cn('whitespace-nowrap text-xl leading-none', isBangles && 'py-[15px]')}>
            {discountedPrice !== null && (
              <span className="selling-price mr-2.5 inline-block">{formatDisplayPrice(discountedPrice)}</span>
            )}
            {hasDiscount && price !== null && (
              <span className="strike-price inline-block text-sm text-[#666666] line-through">
                {formatDisplayPrice(price)}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
);
